import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=3641f3fa&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=3641f3fa&prod&lang=less&scoped=true"
import style1 from "./MenuItem.vue?vue&type=style&index=1&id=3641f3fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641f3fa",
  null
  
)

export default component.exports